export enum Services {
  GATEWAY_API,
  MAIN_API,
  ORDER_API,
  SHIPPING_API,
}

export const SERVICES_URL = {
  [Services.MAIN_API]: process.env.REACT_APP_API_ENDPOINT,
  [Services.ORDER_API]: process.env.REACT_APP_ORDER_API_URL,
  [Services.SHIPPING_API]: process.env.REACT_APP_SHIPPING_API_URL,
  [Services.GATEWAY_API]:
    process.env.REACT_APP_API_ENDPOINT || "http://localhost:8083",
};
